export function pickDataForPDPGTM(category, slug) {
	let dataLayerValues = {
		category,
		slug
	};

	return dataLayerValues;

}